import React, { useState, useRef, useEffect } from 'react';
import { Radio } from 'antd';
import ReactDOM from 'react-dom';
import WebsitePopup from './WebsitePopup';
import OnlineAddComponent from './OnlineAddComponent';
import './WebsiteContainerPopup.css';
import languageManager from '../../utils/languageManager';

// 导入卡片组件列表容器
import CardComponent from './cards/CardComponent';

// 手动添加组件（现有的WebsitePopup内容）
const ManualAddComponent = ({ onClose, onSave, onSaveAndContinue, initialData }) => {
  // 直接使用现有的WebsitePopup组件，但去掉外层的Portal包装
  return <WebsitePopup onClose={onClose} onSave={onSave} onSaveAndContinue={onSaveAndContinue} initialData={initialData} isInContainer={true} />;
};

const WebsiteContainerPopup = ({ onClose, onSave, onSaveAndContinue, initialData }) => {
  const [mode, setMode] = useState('manual'); // online: 在线添加, manual: 手动添加, card: 卡片组件
  const containerRef = useRef(null);

  const handleModeChange = (e) => {
    setMode(e.target.value);
  };

  // 添加点击外部关闭弹窗的处理
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClose();
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  const renderContent = () => {
    switch (mode) {
      case 'online':
        return <OnlineAddComponent onClose={onClose} onSave={onSave} onSaveAndContinue={onSaveAndContinue} initialData={initialData} />;
      case 'manual':
        return <ManualAddComponent onClose={onClose} onSave={onSave} onSaveAndContinue={onSaveAndContinue} initialData={initialData} />;
      case 'card':
        return <CardComponent onClose={onClose} onSave={onSave} initialData={initialData} />;
      default:
        return <OnlineAddComponent onClose={onClose} onSave={onSave} onSaveAndContinue={onSaveAndContinue} initialData={initialData} />;
    }
  };

  return ReactDOM.createPortal(
    <div className="popup-overlay">
      <div ref={containerRef}>
        {/* Tab切换器移到弹窗外面 */}
          <div className="tab-switcher">
            {/* 关闭按钮放在Tab切换器右上角 */}
            <button className="container-popup-close-button" onClick={onClose}>
              ×
            </button>
            
            <Radio.Group 
              onChange={handleModeChange} 
              value={mode} 
              className="tab-radio-group"
            >
              <Radio.Button value="online" className="tab-radio-button">
                {languageManager.t('auth.hotAdd')}
              </Radio.Button>
              <Radio.Button value="manual" className="tab-radio-button">
                {languageManager.t('auth.manuallyAdd')}
              </Radio.Button>
              <Radio.Button value="card" className="tab-radio-button">
                {languageManager.t('auth.cardComponent')}
              </Radio.Button>
            </Radio.Group>
          </div>

        {/* 弹窗内容区域 */}
        <div className="website-container-popup">
          {/* 内容区域 */}
          <div className="tab-content-container">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default WebsiteContainerPopup; 